import { isInteger, isNumber } from 'lodash';
import { z } from 'zod';
import { formatYyyyMmDd } from '@/lib/utils';

export const integerLike = z.union([z.string().transform(Number).refine(isInteger), z.number().refine(isInteger)]);

export const zeroOrOneLike = z
  .union([z.literal(0), z.literal(1), z.literal('0'), z.literal('1'), z.boolean()])
  .transform(val => {
    if (typeof val === 'boolean') {
      return val ? 1 : 0;
    }
    return Number(val);
  });

export const fromToday = z.date().refine(date => {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);
  return date >= now;
});

export const dateLike = z
  .string()
  .refine(date => {
    const dateObj = new Date(date);
    return !isNaN(dateObj.getTime());
  })
  .transform(date => {
    const dateObj = new Date(date);
    return formatYyyyMmDd(dateObj);
  });
